import { AnimatePresence, motion } from 'framer-motion'
import React, { useState } from 'react'
import styled from 'styled-components'

interface Props {
  /** Always-visible text. The toggle link appears inline right after it. */
  summary: React.ReactNode
  label: string
  labelCollapse?: string
  children: React.ReactNode
  defaultOpen?: boolean
  /** Optional className applied to the summary paragraph */
  summaryClassName?: string
}

export const ExpandableText: React.FC<Props> = ({
  summary,
  label,
  labelCollapse,
  children,
  defaultOpen = false,
  summaryClassName
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <Wrapper>
      <SummaryLine className={summaryClassName}>
        {summary}{' '}
        <Toggle onClick={() => setIsOpen(v => !v)}>
          {isOpen && labelCollapse ? labelCollapse : `${label}...`}
        </Toggle>
      </SummaryLine>
      <AnimatePresence>
        {isOpen && (
          <Content
            key="expandable-content"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.15 }}
          >
            {children}
          </Content>
        )}
      </AnimatePresence>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const SummaryLine = styled.p`
  margin: 0;
`

const Toggle = styled.button`
  display: inline;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  color: inherit;
  opacity: 0.6;
  text-decoration: underline;

  &:hover {
    opacity: 1;
  }
`

const Content = styled(motion.div)`
  overflow: hidden;
`
